(() => {
  const HOST = "span._paidy-promotional-messaging";
  const FONT_SIZE = "calc(var(--font-3) * var(--FONT-ADJUST-BODY))";
  const SCALE = 0.8;
  const px = (v) => {
    const m = String(v || "").match(/([\d.]+)px/i);
    return m ? Number(m[1]) : null;
  };

  const apply = (root = document) => {
    root.querySelectorAll(HOST).forEach((host) => {
      host.style.setProperty("width", "100%", "important");
      host.style.setProperty("max-width", "100%", "important");
      host.querySelectorAll("span").forEach((sp) => {
        sp.style.setProperty("font-size", FONT_SIZE, "important");
      });

      host.querySelectorAll("div").forEach((div) => {
        if (px(div.style.padding) === 16) {
          div.style.setProperty("padding-top", "8px", "important");
          div.style.setProperty("padding-right", "0px", "important");
          div.style.setProperty("padding-bottom", "0px", "important");
          div.style.setProperty("padding-left", "0px", "important");
        }
      });

      host.querySelectorAll("img").forEach((img) => {
        const src = img.getAttribute("src") || "";
        if (!src.includes("paidy-text-")) return;

        if (img.dataset.awScaled === "1") return;

        const w = px(img.style.width);
        const h = px(img.style.height);

        if (w) img.style.setProperty("width", `${w * SCALE}px`, "important");
        if (h) img.style.setProperty("height", `${h * SCALE}px`, "important");

        img.dataset.awScaled = "1";
      });
    });
  };

  apply();

  let timer = null;
  const schedule = () => {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => apply(), 0);
  };

  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
